import { render, staticRenderFns } from "./ShipmentPlanners.vue?vue&type=template&id=52a8a93d"
import script from "./ShipmentPlanners.vue?vue&type=script&lang=js"
export * from "./ShipmentPlanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports